export class Page<T> {
  content: T[];
  totalSize: number;
  constructor() {
  }
}

